<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="F30" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ugvcwnh1j31hc0rsgoe.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uj4wfnegj30ku0rs75j.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation2" :style="{width: clientWidth * 0.625 + 'px'}">
            <div>
                <p style="margin-top: 270px;"><img :width="clientWidth * 0.29" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uhns7xnsj30ff034aa8.jpg"/></p>
                <!-- <h4 style="font-size: 14px; color: #999; margin-top: 168px;">可选颜色</h4> -->
                <div class="pro_color_box" style="margin-top:68px; width: 450px;">
                    <div class="pro_type">
                        <span @click="switchType(0)">3.5mm普通版</span>
                        <span @click="switchType(1)">Type-C版</span>
                    </div>
                    <ul v-if="seletedType === 0">
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>碳晶黑</li>
                        <!-- <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>珍珠白</li> -->
                        <!-- <li :class="{active: seletedColor == 2}" @click="switchColor(2)"><i></i>珊瑚红</li> -->
                    </ul>
                    <ul v-if="seletedType === 1">
                        <li :class="{active: seletedColor == 3}" @click="switchColor(0)"><i></i>碳晶黑</li>
                    </ul>
                </div>
                <p style="margin-top: 50px; margin-bottom: 230px"><img :width="clientWidth * 0.186" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uhnstq55j309y027glk.jpg"/></p>
            </div>
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <!-- <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper> -->
                <!-- <swiper :options="swiperOption" v-else-if="seletedColor === 2">
                    <swiper-slide v-for="(item, index) in earphones3" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper> -->
                <swiper :options="swiperOption" v-if="seletedColor === 3" ref="swiperThumbs">
                    <swiper-slide v-for="(item, index) in earphones4" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
            </div>
        </div>
        <!-- 移动端轮播图 -->
        <div class="pro_animation">
            <p style=" margin-top: 2.048rem; text-align: center;"><img style="width: 11.3067rem;" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ujg5dowtj30eq03iq32.jpg"/></p>
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <!-- <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else-if="seletedColor === 2">
                    <swiper-slide v-for="(item, index) in earphones3" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper> -->
                <swiper :options="swiperOption" v-else-if="seletedColor === 3" ref="swiperThumbs">
                    <swiper-slide v-for="(item, index) in earphones4" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <div class="pro_color_box">
                    <ul v-if="seletedType === 0">
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>碳晶黑</li>
                        <!-- <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>珍珠白</li>
                        <li :class="{active: seletedColor == 2}" @click="switchColor(2)"><i></i>珊瑚红</li> -->
                    </ul>
                    <ul v-if="seletedType === 1">
                        <li :class="{active: seletedColor == 3}" @click="switchColor(0)"><i></i>碳晶黑</li>
                    </ul>
                    <div class="pro_type">
                        <span @click="switchType(0)">3.5mm普通版</span>
                        <span @click="switchType(1)">Type-C版</span>
                    </div>
                </div>
            </div>
            <p><img style="width: 11.1253rem;" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ujm5639nj309a03a748.jpg"/></p>
        </div>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1gdwjuyhklij31hc0rs7hl.jpg"/>
        <!-- <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ugve2qryj31hc0rsq59.jpg"/> -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ugvf5197j31hc0rsq53.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ugvfrb81j31hc0rs42h.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ugvg79onj31hc0rsgpk.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ugvgm6ibj31hc0rsmz8.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gdwjv0un4yj31hc0rswm5.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ugvhp4jlj31hc0rsgnz.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ugvi92ifj31hc0rs44l.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gdwjv2zmtwj31hc0rs41b.jpg"/>
        
        <!-- <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g6uj4xgr2tj30ku0rsmyo.jpg"/> -->
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uj4y100ij30ku0rsgo1.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uj4ytayij30ku0rswgw.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gdzh0bjsuhj30ku0rsq6q.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uj50i8bxj30ku0rsn0j.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uj50xfdij30ku0rsjsd.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uj51bytfj30ku0rs75o.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            seletedType: 0, 
            earphones4: ["http://wx4.sinaimg.cn/large/0067mezugy1g6uhd6f187j30j20rsmxx.jpg","http://wx2.sinaimg.cn/large/0067mezugy1g6uhd4t6b8j30ix0rsq3m.jpg", "http://wx4.sinaimg.cn/large/0067mezugy1g6uhd5hnx2j30ix0rsaao.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g6uhd5zt9kj30ix0rst9g.jpg"],
            earphones3: ["http://wx3.sinaimg.cn/large/0067mezugy1g6uhd71oe4j30j20rsaar.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g6uhd7qk23j30j20rs74y.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g6uhd8arnwj30j20rst9e.jpg"],
            earphones2: ["http://wx3.sinaimg.cn/large/0067mezugy1g6uhd35f2dj30ix0rsjrq.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g6uhd3pq1jj30ix0rst99.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g6uhd4c3erj30ix0rsjs2.jpg"],
            earphones1: ["http://wx2.sinaimg.cn/large/0067mezugy1g6uhd4t6b8j30ix0rsq3m.jpg", "http://wx4.sinaimg.cn/large/0067mezugy1g6uhd5hnx2j30ix0rsaao.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g6uhd5zt9kj30ix0rst9g.jpg"],
            clientWidth: document.body.clientWidth
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        },
        switchType(type){
            this.seletedType = type;
            if(type === 0){
                this.seletedColor = 0;
            }else{
                this.seletedColor = 3;
                this.$nextTick(() => {
                    console.log(this.$refs.swiperThumbs.swiper)
                    this.$refs.swiperThumbs.swiper.slideTo(1)
                })
                
            }
        }
    },
    beforeMount(){
        window.addEventListener("resize", () => {
            this.clientWidth = document.body.clientWidth
        })
    }
}
</script>
<style scoped>

.pro_color_box li:nth-child(1) i::before{
	background-image: url(../../../assets/img/icons/pa_01.jpg);
}

.pro_color_box li:nth-child(2) i::before{
	background-image: url(../../../assets/img/icons/pa_04.jpg);
}

.pro_color_box li:nth-child(3) i::before{
	background-image: url(../../../assets/img/icons/pa_02.jpg);
}

.pro_animation2 .pro_animation_item{
    /* height: 700px; */
    padding-bottom: 100px; 
}


.pro_animation2 .swiper-container{
    margin-top: 120px;
}


@media (max-width: 768px) {
    
    /* .pro_animation_item img{
		width: 16rem; 
    }
     */
    .pro_color_box{
        width: 11.6733rem;
        margin: 1.0333rem auto;
        font-size: 0.256rem;
    }

    .pro_color_box ul{
        overflow: hidden;
        
    }
    .pro_color_box ul li{
        font-size: 0.2987rem;
        width: 100%
    }
     .pro_color_box .pro_type{
        margin-top: 0.8533rem;
        margin-bottom: 0;
     }
    .pro_color_box .pro_type span{
        font-size: 0.2987rem;
       
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/F/f30.vue